import "./utils/Sentry";
import "@coreui/coreui/dist/css/coreui.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./App.scss";
import App from "./App";
import ModalWindowProvider from "./contexts/ModalWindowProvider";
import { Auth0Provider } from "@auth0/auth0-react";
import { SessionProvider } from "./contexts/SessionContext";
import { AuthInterceptorSetup } from "./components/AuthInterceptorSetup";
import { LoginCallbackHandler } from "./components/LoginCallbackHandler";
import { Provider } from "react-redux";
import { store } from "./store";
import LogRocket from "logrocket";

const root = ReactDOM.createRoot(document.getElementById("root"));
const isProduction = window.location.hostname === "app.trilodocs.com";
console.log("Environment:", process.env.NODE_ENV, "Production:", isProduction);
if (isProduction) {
  LogRocket.init("sagsim/trilodocs");
}
root.render(
  <Provider store={store}>
    <ModalWindowProvider>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        useRefreshTokens={true}
        cacheLocation="localstorage"
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid email profile offline_access",
        }}>
        <AuthInterceptorSetup />
        <SessionProvider>
          <LoginCallbackHandler>
            <App />
          </LoginCallbackHandler>
        </SessionProvider>
      </Auth0Provider>
    </ModalWindowProvider>
  </Provider>
);
